import type { GridRowId, GridRowSelectionModel } from "@mui/x-data-grid";

// MUI X v9 replaced the `GridRowId[]` selection model with `{ type, ids: Set<GridRowId> }`.
// These helpers keep call sites reading selection as ids/count/membership as before.

export const EMPTY_ROW_SELECTION: GridRowSelectionModel = {
  type: "include",
  ids: new Set<GridRowId>(),
};

export const getSelectedRowIds = (model: GridRowSelectionModel): GridRowId[] =>
  Array.from(model.ids);

export const getSelectedRowCount = (model: GridRowSelectionModel): number =>
  model.ids.size;

export const isRowSelected = (
  model: GridRowSelectionModel,
  id: GridRowId
): boolean => model.ids.has(id);

export const toRowSelectionModel = (
  ids: GridRowId[]
): GridRowSelectionModel => ({ type: "include", ids: new Set(ids) });
